import React from "react"

import { Navbar } from "@/app-shell/navigation/Navbar"
import SidebarNav from "@/app-shell/navigation/SidebarNav"
import { Show } from "@clerk/nextjs"
import { cn } from "@coval/ui"

import Footer from "@/components/shared/footer/Footer"
import { DebugInfoPanel } from "@/components/shared/keyboard-commands/DebugInfoPanel"

import { useAppShellContributions } from "../navigation/AppShellContributionsContext"
import { Head } from "./Head"

interface DefaultLayoutProps {
  children: React.ReactNode
  className?: string
}

export default function DefaultLayout({
  children,
  className = "",
}: DefaultLayoutProps) {
  const appShellContributions = useAppShellContributions()

  return (
    <div className={cn("relative flex flex-col h-screen", className)}>
      <Head />
      <Show when="signed-out">
        <Navbar />
        <main className="container mx-auto max-w-7xl px-6 grow pt-8">
          {children}
        </main>
        <Footer />
      </Show>
      <Show when="signed-in">
        <SidebarNav>{children}</SidebarNav>
        {appShellContributions.renderCommandPalette?.()}
        <DebugInfoPanel />
      </Show>
    </div>
  )
}
